import AutoloadViews from "@galaxy/modules/Core/resources/js/AutoloadViews";
import vueCustomElement from 'vue-custom-element';
import Vue from 'vue';

// Load all js files
AutoloadViews.load('shop::', require.context('./../', true, /.(js|vue)$/));

// Init custom vue Components
Vue.use(vueCustomElement);

// Add custom elements
Vue.customElement('shop-website-modules-shopproducts-show-productvariantselector', require('./../components/website/modules/shopProducts/show/ProductVariantSelector.vue').default);
